import { Link } from '@tanstack/react-router';
import { LOGO_DISPLAY } from '../../lib/seo';
import type { CategoryItem } from './Menu';
import { SocialIconList } from './SocialIconList';

function NewsletterForm() {
  return (
    <div className="footer-newaletter">
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="input-box">
          <input
            type="email"
            required
            placeholder="البريد الإلكتروني"
            className="form-control"
            aria-label="البريد الإلكتروني"
          />
          <button type="submit" className="btn">
            اشترك
          </button>
        </div>
      </form>
      <p>توصل بالأخبار المهمة والحصرية</p>
    </div>
  );
}

function chunk<T>(arr: T[], size: number): T[][] {
  const out: T[][] = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
}

function CategoryColumn({
  title,
  items,
  variant,
}: {
  title: string;
  items: CategoryItem[];
  variant?: 'list-2';
}) {
  return (
    <div className="col-lg-4 col-md-4">
      <div className={`widget widget-list${variant === 'list-2' ? ' widget-list-2' : ''}`}>
        <div className="section-title section-title-2">
          <h3 className="title">{title}</h3>
        </div>
        <div className="list d-flex justify-content-between">
          {chunk(items, 7).map((group, i) => (
            <ul key={i}>
              {group.map((cat) => (
                <li key={cat.id}>
                  <Link to="/category/$" params={{ _splat: cat.slug }} search={{ page: undefined }}>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </div>
  );
}

export function Footer({
  mainCategories = [],
  otherCategories = [],
}: {
  mainCategories?: CategoryItem[];
  otherCategories?: CategoryItem[];
}) {
  const year = new Date().getFullYear();

  return (
    <>
      <footer className="footer-area">
        <div className="container">
          <div className="footer-topbar">
            <div className="row align-items-center">
              <div className="col-lg-7 col-md-5">
                <div className="footer-logo">
                  {/* Was `href="#"`; a footer logo is the conventional link home. */}
                  <Link to="/">
                    <img
                      src={LOGO_DISPLAY.url}
                      alt="تلي صافي"
                      width={100}
                      height={100}
                      loading="lazy"
                      style={{ width: '100px' }}
                    />
                  </Link>
                  <SocialIconList />
                </div>
              </div>
              <div className="col-lg-5 col-md-7">
                <NewsletterForm />
              </div>
            </div>
          </div>

          <div className="footer-widget-area">
            <div className="row">
              <div className="col-lg-12">
                <div className="footer-widget-right-border">
                  <div className="row">
                    <CategoryColumn title="الأقسام الإخبارية" items={otherCategories} />
                    <CategoryColumn title="أقسام أخرى" items={mainCategories} variant="list-2" />
                    <div className="col-lg-4 col-md-4">
                      <div className="widget widget-list widget-list-2">
                        <div className="section-title section-title-2">
                          <h3 className="title">روابط مهمة</h3>
                        </div>
                        <div className="list d-flex justify-content-between">
                          <ul>
                            <li><Link to="/">الواجهة الرئيسية</Link></li>
                            <li><Link to="/join">إنضم إلينا</Link></li>
                            <li><Link to="/contact">تواصل معنا</Link></li>
                            <li><Link to="/sitemap">خريطة الموقع</Link></li>
                            <li><Link to="/advertising">الإعلان</Link></li>
                            <li><Link to="/privacy">سياسية الخصوصية</Link></li>
                            <li><Link to="/terms">الشروط والأحكام</Link></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className="footer-copyright">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="copyright-item d-block d-md-flex justify-content-between align-items-center">
                <p>© {year} - جميع الحقوق محفوظة.</p>
                <ul>
                  <li><Link to="/about">عن الموقع</Link></li>
                  <li><Link to="/advertising">الاعلان</Link></li>
                  <li><Link to="/privacy">الخصوصية والسياسة</Link></li>
                  <li><Link to="/contact">اتصل بنا</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
